export default __webpack_public_path__ + "2baa295655e564adad38d39e5a45149b.png";